import { createApp } from "vue";
import App from "./App.vue";
import { setupRouter } from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/css/style.css";
import en from "./locales/en.json";
import { setupI18n } from "@/i18n";
import dateTimeFormats from "./locales/dateTimeFormats.json";

const i18n = setupI18n({
  datetimeFormats: dateTimeFormats,
  globalInjection: true,
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en,
  },
});

const app = createApp(App);
const router = setupRouter(i18n);

app.use(store);
app.use(i18n);
app.use(router);
app.mount("#app");
